import React from 'react'

export default function HeaderSection({icon, title}) {
  return (
   <div className="bg-gradient-to-r from-[#0b3a5c] to-[#135e96] px-6 py-4">
                          <div className="flex items-center justify-between">
                            <div className="flex items-center gap-3">
                             {icon}
                              <h2 className="text-xl font-bold text-white">
                                {title}
                              </h2>
                            </div>

                          </div>
                        </div>
  )
}
